/* eslint @typescript-eslint/no-var-requires: "off" */
import * as api from "../constant/NewAPI";
import React, { useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";


// const api = require("../constant/API");
// const api = require("../constant/NewAPI");

const TenvicLogin = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("");
  const [error, setError] = useState("");
  const [fgtUsrNameError, setFgtUsrNameError] = useState("");
  const [fgtEmailError, setFgtEmailError] = useState("");
  const [fgtUsrName, setFgtUsrName] = useState("");
  const [fgtUsrEmail, setFgtUsrEmail] = useState("");
  const [openModal, setOpenModal] = useState(false)

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  function login() {
    // if (!userType) {
    //   setError("Please select a user type.");
    //   return;
    // }

    const formData = new FormData();

    // formData.append('userType', userType);
    formData.append('username', userName);
    formData.append('password', password);

    const data = {
      // userType: userType,
      userName: userName,
      userPasswd: password
    };

    const login = api.institutionLogin;
    fetch(login, {
      method: "POST",
      body: JSON.stringify(data)
    })
      .then((loginResponse) => loginResponse.json())
      .then((loginResult) => {
        if (loginResult.data == 'Error') {
          setError("User Credentials not valid. Please try again!");
        }
        else {

          const loggedIn = loginResult.data;

          localStorage.setItem('UserId', loggedIn.internalUserId); //not
          localStorage.setItem('UserName', loggedIn.internalUserName);
          localStorage.setItem('UserFirstName', loggedIn.internalUserFirstName);//not
          localStorage.setItem('UserLastName', loggedIn.internalUserLastName);//not
          localStorage.setItem('RoleId', loggedIn.internalUserRoleId);
          localStorage.setItem('SportId', loggedIn.internalSportId);
          localStorage.setItem('ManagerId', loggedIn.internalUserManagerId);
          localStorage.setItem('UserModule', loggedIn.internalUserModule);
          localStorage.setItem('FullName', loggedIn.internalUserName)
          localStorage.setItem('accessToken', loggedIn.token)
          localStorage.setItem('accessConfigValue', "1800");
          localStorage.setItem('refreshConfigValue', "1500");
          localStorage.setItem('closeConfigValue', "1800");

          setError("");
          navigate(route.general);
        }
      })
      .catch((error) => {
        console.log("Failed to login", error);
      })
  }

  function requestLink() {
    const formData = new FormData();
    formData.append('username', fgtUsrName)
    formData.append('email', fgtUsrEmail)
    formData.append('type', 'institution')
    const getLink = api.ForgotPasswordLink;
    fetch(getLink, {
      method: "POST",
      body: formData
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.error == false) {
          Swal.fire(result.message)
        } else {
          Swal.fire(result.message)
        }
      })
    setOpenModal(false)
  }

  function validateUserName(name) {
    const checkname = api.CheckUserName + '/' + name + '/institution';
    fetch(checkname, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.error == true) {
          setFgtUsrNameError('Not Valid')
        } else {
          setFgtUsrNameError('Valid')
        }
      })
  }

  function validateUserEmail(mail) {
    const formData = new FormData();
    formData.append('username', fgtUsrName);
    formData.append('userEmail', mail);
    formData.append('type', 'institution');
    const checkemail = api.CheckUserEmail;
    fetch(checkemail, {
      method: "POST",
      body: formData
    })
      .then((response) => response.json())
      .then((result) => {

        if (result.error == true) {
          setFgtEmailError('Not Valid')
        } else {
          setFgtEmailError('Valid')
        }
      })
  }

  const tenvicStaff = () => {
    setUserType("internalUser");
    setError("");
  };

  const institute = () => {
    setUserType("institution");
    setError("");
  };

  const student = () => {
    setUserType("coreLogin");
    setError("");
  };

  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper authendication-pages">
        {/* Page Content */}
        <div className="content">
          <div className="container wrapper no-padding">
            <div className="row no-margin vph-100">
              <div className="col-12 col-sm-12 col-lg-6 no-padding">
                <div className="banner-bg login">
                  <div className="row no-margin h-100">
                    <div className="col-sm-10 col-md-10 col-lg-10 mx-auto">
                      <div className="h-100 d-flex justify-content-center align-items-center">
                        <div className="register text-center">
                          <button
                            type="button"
                            className="btn btn-limegreen"
                          >
                            <i className="fa-solid fa-thumbs-up me-3" />
                            sAMSara
                          </button>
                          {/* <p>
                            Log in right away for our advanced sports software
                            solutions, created to address issues in regular
                            sporting events and activities.
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12  col-lg-6 no-padding">
                <div className="dull-pg">
                  <div className="row no-margin vph-100 d-flex align-items-center justify-content-center">
                    <div className="col-sm-10 col-md-10 col-lg-10 mx-auto">
                      <header className="text-center">
                        <Link to='/'>
                          <ImageWithBasePath
                            src="assets/img/Tenvic/TENVICLogo.png"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </Link>
                      </header>
                      <div className="shadow-card">
                        <p>Login into your account</p>
                        {/* <ul className="nav nav-tabs" id="myTab" role="tablist" style={{ margin: "10px" }}>
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link d-flex align-items-center"
                              id="user-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#user"
                              type="button"
                              role="tab"
                              aria-controls="user"
                              aria-selected="true"
                              onClick={tenvicStaff}
                            >
                              <span className="d-flex justify-content-center align-items-center" />
                              Tenvic Staff
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link d-flex align-items-center"
                              id="coach-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#user"
                              type="button"
                              role="tab"
                              aria-controls="user"
                              aria-selected="false"
                              onClick={institute}
                            >
                              <span className="d-flex justify-content-center align-items-center" />
                              Institute
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link d-flex align-items-center"
                              id="student-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#user"
                              type="button"
                              role="tab"
                              aria-controls="user"
                              aria-selected="false"
                              onClick={student}
                            >
                              <span className="d-flex justify-content-center align-items-center" />
                              Student
                            </button>
                          </li>
                        </ul>        */}
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            {/* Login Form */}
                            <form onSubmit={(e) => { e.preventDefault(); login(); }}>
                              <div className="form-group">
                                <div className="group-img">
                                  <i className="feather-user" />
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Email / Username"
                                    value={userName}
                                    onChange={(e) =>
                                      setUserName(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="form-group">
                                <div className="pass-group group-img">
                                  <i
                                    className={`toggle-password ${passwordVisible ? "feather-eye" : "feather-eye-off"}`}
                                    onClick={togglePasswordVisibility}
                                  />
                                  <input
                                    type={passwordVisible ? "text" : "password"}
                                    className="form-control pass-input"
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="form-group d-sm-flex align-items-center justify-content-between">
                                <div className="form-check form-switch d-flex align-items-center justify-content-start">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="user-pass"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="user-pass"
                                  >
                                    Remember Password
                                  </label>
                                </div>
                                {/* <span>
                                  <Link
                                    // to={route.forgotPasssword}
                                    to="#"
                                    onClick={() => setOpenModal(true)}
                                    className="forgot-pass"
                                  >
                                    Forgot Password
                                  </Link>
                                </span> */}
                              </div>
                              {error && <div className="alert alert-danger">{error}</div>}
                              {/* <Link
                                to={userType ? route.general : "#"}
                                // to="#"
                                className="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                                onClick={login}
                              >
                                Sign In
                                <i className="feather-arrow-right-circle ms-2" />
                              </Link> */}
                              <button
                                type="submit"
                                className="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                              >
                                Sign In
                                <i className="feather-arrow-right-circle ms-2" />
                              </button>
                            </form>
                            {/* /Login Form */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
      {/* /Main Wrapper */}

      <Modal
        show={openModal}
        size="md"
        centered
        onHide={() => setOpenModal(false)}
      >
        <ModalHeader>
          <ModalTitle><h4 className="text-center"><i className="fas fa-key" />Forgot Password</h4></ModalTitle>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setOpenModal(false)}
          ></Button>
        </ModalHeader>
        <ModalBody>
          <div className="col-lg-12 mb-10">
            <label className="form-label">Username
              {fgtUsrNameError && <span style={{ color: fgtUsrNameError === '  Valid' ? 'green' : 'red' }}>{fgtUsrNameError}</span>}
            </label>
            <input
              type="text"
              className="form-control"
              style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
              id="usrnm"
              value={fgtUsrName}
              onChange={(e) => { setFgtUsrName(e.target.value); validateUserName(e.target.value); }}
              placeholder="Username"
            />
          </div>
          <div className="col-lg-12 mb-10">
            <label className="form-label">E Mail
              {fgtEmailError && <span style={{ color: fgtEmailError === '  Valid' ? 'green' : 'red' }}>{fgtEmailError}</span>}
            </label>
            <input
              type="email"
              className="form-control"
              style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
              id="stksze"
              value={fgtUsrEmail}
              onChange={(e) => { setFgtUsrEmail(e.target.value); validateUserEmail(e.target.value) }}
              placeholder="E Mail"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-primary text-uppercase"
            variant="success"
            onClick={() => { requestLink(); setOpenModal(false) }}
            data-bs-dismiss="modal" aria-label="Close"
          >
            <b><i className="fas fa-save" /> Request</b>
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default TenvicLogin;
